export default __webpack_public_path__ + "static/media/sub-category-eventsAndVenues-conferenceExhibition.4074db06.jpg";